// @flow weak

import {combineReducers} from 'redux';
import _ from 'lodash/fp';
import {
  GET_REQUEST,
  GET_SUCCESS,
  GET_FAILURE,
  FILTER_QUERY,
  FILTER_PROJECT_ID,
  FILTER_PURCHASED,
  SORT,
} from '../actions/purchaseOrderList';
import {CONFIRMED} from '../orderStates';
import {totalPrice} from '../helpers/priceHelpers';

const isFetching = (state = false, action) => {
  switch (action.type) {
    case GET_REQUEST:
      return true;
    case GET_SUCCESS:
    case GET_FAILURE:
      return false;
    default:
      return state;
  }
};

const error = (state = null, action) => {
  switch (action.type) {
    case GET_SUCCESS:
      return null;
    case GET_FAILURE:
      return action.error;
    default:
      return state;
  }
};

const mapOrders =
  _.map(o => ({
    ...o,
    totalPrice: totalPrice(o),
  }));

const filterByProjectId = projectId =>
  _.filter(
    _.flow(
      _.get('apartment.projectId'),
      _.isEqual(projectId)
    )
  );

const notArchived =
  _.filter({archived: null});

const filterOrders = ({projectId, isPurchased} = {}) => {
  let filterFunc = _.flow(
    notArchived,
    isPurchased
      ? _.filter(o => o.state > CONFIRMED)
      : _.filter({state: CONFIRMED})
  );

  if (projectId) {
    filterFunc = _.flow(
      filterFunc,
      filterByProjectId(projectId)
    );
  }

  return filterFunc;
};

const defaultOrdersState = {
  list: [],
  filteredList: [],
  filters: {
    query: '',
    isPurchased: false,
    projectId: null,
  },
  sorter: _.identity,
};

const orders = (state = defaultOrdersState, action) => {
  switch (action.type) {
    case GET_SUCCESS: {
      const orders = mapOrders(action.orders);
      return {
        ...state,
        list: orders,
        filteredList: _.flow(
          filterOrders(state.filters),
          state.sorter,
        )(orders),
      };
    }
    case FILTER_PROJECT_ID: {
      const filters = {
        ...state.filters,
        projectId: action.projectId,
      };
      return {
        ...state,
        filters,
        filteredList: _.flow(
          filterOrders(filters),
          state.sorter,
        )(state.list),
      };
    }
    case FILTER_PURCHASED: {
      const filters = {
        ...state.filters,
        isPurchased: action.purchased,
      };
      return {
        ...state,
        filters,
        filteredList: _.flow(
          filterOrders(filters),
          state.sorter,
        )(state.list),
      };
    }
    case FILTER_QUERY:
      return {
        ...state,
        filters: {
          ...state.filters,
          query: action.query,
        },
      };
    case SORT:
      return {
        ...state,
        sorter: action.sorter,
        filteredList: _.flow(
          filterOrders(state.filters),
          action.sorter,
        )(state.list),
      };
    default:
      return state;
  }
};

const mapProjects =
  _.flow(
    _.map('apartment.project'),
    _.uniqBy('id')
  );

const projects = (state = [], action) => {
  switch (action.type) {
    case GET_SUCCESS:
      return mapProjects(action.orders);
    default:
      return state;
  }
};

const sorter = (state = _.identity, action) => {
  switch (action.type) {
    case SORT:
      return action.sorter;
    default:
      return state;
  }
};

const purchaseOrderList = combineReducers({
  isFetching,
  error,
  orders,
  projects,
  sorter,
});

export default purchaseOrderList;



// WEBPACK FOOTER //
// ./src/reducers/purchaseOrderList.js